import React, { useState, useEffect } from "react";

import { func_validation } from "functions";

import "awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css";

import "assets/scss/components/form/formRadio.scss";



/* Props 
 * {
 *      // Data
 *      radioGroupName: "",
 *      radioID: "",
 *      radioValue: "",
 *      radioLabel: "",
 * 
 *      // State managed by parent
 *      radioSelected: "",
 * 
 *      // Options
 *      isRadioDisabled: false,
 * 
 *      // State Propagation
 *      handleRadioSelection: (e, radioGroupName, radioID, value)=>{};
 * }
 */

export function FormRadio(props) {
    const { 
        className,
        labelClassName,

        radioGroupName, radioID: radioID_props, 
        radioValue, radioLabel,

        isSelected,

        isRadioDisabled, isError
    } = props;

    // Props validated
    let radioID_validated = func_validation.isStringTrimNotEmpty(radioID_props)? radioID_props: func_validation.getStringUniqueId("form-check-input");

    // States
    const [radioID] = useState(radioID_validated);

    function onClick_handleRadio(e) {

        // Update parent state
        if (props.handleRadioSelection &&
            func_validation.isNotNullUndefined(radioValue)) 
            props.handleRadioSelection(radioValue, radioID);
    }

    return (
        <div className={"component-formRadio " +
                (className? className + " ":"")}>

            {/* Radio Wrapper */}
            <div className="component-formRadioWrapper form-check abc-radio">

                {/* Radio Input */}
                <input className="component-formRadio-input" type="radio" 
                    name={radioGroupName} 
                    id={radioID} value={radioValue}
                    onChange={onClick_handleRadio}
                    checked={isSelected}
                    disabled={isRadioDisabled}
                />

                {/* Radio Label */}
                <label htmlFor={radioID}
                    className={"component-formRadio-label " +
                        (labelClassName? labelClassName + " ":"") +
                        (isError? "component-formRadio-label_error ":"") + 
                        (isSelected? "component-formRadio-label_primaryBorder ":"")}
                >
                    {radioLabel}
                </label>

            </div>

        </div>
    );
}